'use strict';

const $ = require('jquery');

class Form {

    constructor() {

        //  Form manipulations on submit (AJAX form)
        let form_observer = new MutationObserver(function (mutationsList) {
            Form.prototype.renderForm(mutationsList[0].target)
        });

        $('.gform_wrapper').each(function () {
            Form.prototype.renderForm(this);

            form_observer.observe(this, {childList: true});
        });
    }

    renderForm(formWrapper) {

        let $formWrapper = $(formWrapper);

        //  Remove all tabindexes to avoid switching between forms
        $formWrapper.find('input, select, textarea, button, .gform_anchor').removeAttr('tabindex');

        $formWrapper.find('.ginput_container_checkbox').parent().addClass('checkbox-field');
        $formWrapper.find('textarea').closest('li').addClass('textarea-field');
        $formWrapper.find('select').closest('li').addClass('select-field');
        $formWrapper.find('.ginput_container_fileupload').closest('li').addClass('upload-field');

        $formWrapper.find('input[type="text"], input[type="email"], textarea, select')
            .each(function () {
                let $this = $(this);

                if ($this.val() !== '') {
                    $this.closest('li').addClass('focus');
                }
            })
            .on('focus', function () {
                $(this).closest('li').addClass('focus');
            })
            .on('blur', function () {
                let $this = $(this);

                if ($this.val() === '') {
                    $this.closest('li').removeClass('focus');
                }
            });

        //  GravityForms - custom checkboxes and radio's
        let $choiceBoxes = $formWrapper.find('.gfield_radio li, .gfield_checkbox li');

        if ($choiceBoxes.length > 0) {

            $choiceBoxes.each(function () {

                let $this = $(this);
                let oldInput = $this.find('input');
                let className = $this.parent().attr('class').replace('gfield_', '');

                $this
                    .find('label')
                    .addClass(className)
                    .prepend(oldInput);

            });

        }

        //  Custom radio
        $('.checkbox, .radio').closest('label').click(Form.prototype.toggleLabel);
        Form.prototype.toggleLabel();

        let $button = $formWrapper.find('button[type="submit"]');

        $button.addClass('primary icon-right icon-arrow-right');

        let $validationMessage = $('.validation_message');

        $validationMessage.each(function () {

            let $this = $(this);
            let validateMessage = $this.html();

            if (validateMessage === '') {
                $this.remove();
            }

        });

    }

    toggleLabel() {

        $(this).removeClass('selected');
        $(this).filter(':has(:checked)').addClass('selected');

    }

}

module.exports = Form;
